import { SVGProps, Ref, forwardRef } from 'react';

export const UserCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M6.732 6.332c0-.458.117-.767.258-.936.104-.125.345-.33 1.008-.33s.903.205 1.007.33c.141.17.259.478.259.936s-.118.767-.259.937c-.104.125-.344.33-1.007.33s-.904-.205-1.008-.33c-.141-.17-.258-.478-.258-.937"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5c0 2.516-.844 5.032-3.098 6.415v-.014c0-3.303-2.202-4.404-4.404-4.404s-4.404 1.101-4.404 4.404v.012C1.343 13.03.5 10.515.5 8m7.498-4.334c-2 0-2.666 1.333-2.666 2.666s.666 2.666 2.666 2.666 2.666-1.333 2.666-2.666-.667-2.666-2.666-2.666"
                    fill="currentColor"
                />
                <path
                    d="M11.002 15.06c-.854.283-1.85.44-3.002.44-1.155 0-2.151-.158-3.006-.441V14.4c0-1.315.422-1.99.873-2.365.495-.413 1.238-.639 2.131-.639s1.636.226 2.132.64c.45.375.872 1.05.872 2.364z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
UserCircleFilledSize16Glyph.displayName = 'UserCircleFilledSize16Glyph';
